const ProgressBar = ({ bgcolor, progress, height, text, fontSize, title }) => {
  const Parentdiv = {
    height: 15,
    backgroundColor: "#fff",
    borderRadius: 40,
  };

  const Childdiv = {
    height: "100%",
    width: `${progress}%`,
    backgroundColor: bgcolor,
    borderRadius: 40,
  };

  const progresstext = {
    padding: 10,
    color: "black",
    fontSize: 10,
    fontWeight: 900,
    verticalAlign: "top",
  };

  const skillPercent = {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 25,
    fontWeight: "600",
    color: "#173b6c",
  };

  return (
    <>
      <div style={skillPercent}>
        <p style={{ fontSize: `${fontSize}` }}>{text}</p>
        {/* <p style={{fontSize: '16px'}}>{progress}%</p> */}
        <p style={{ fontSize: "16px" }}>{title}</p>
      </div>
      <div style={Parentdiv}>
        <div style={Childdiv}>
          <span style={progresstext}></span>
        </div>
      </div>
    </>
  );
};

export default ProgressBar;
